import { AfterViewInit, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {api} from '../../../api/api-dictionnary';
import {Dossier} from '../../../class/api/Dossier';
import {HydraService} from '../../../core/services/hydra.service';
import {ToolsService} from '../../services/tools/tools.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-grille-expertise',
    templateUrl: './modal-grille-expertise.component.html',
    styleUrls: ['./modal-grille-expertise.component.scss'],
    imports: [CdkScrollable, MatDialogContent, MatDialogActions, MatButton, TranslateModule]
})
export class ModalGrilleExpertiseComponent implements AfterViewInit {
    toolService = inject(ToolsService);
    private hydraService = inject(HydraService);
    dialogRef = inject<MatDialogRef<ModalGrilleExpertiseComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);

    public dossier: Dossier = null;
    public texte: any = null;
    public sommaire = [];

    public langue = 'fr';

    constructor() {

    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    loadHTML() {
        const url = this.getPreviewURL();
        this.hydraService.getHtml(url).subscribe(
            res => {
                this.texte = res;
                this.editHtml();
            },
            () => {
            }
        );
    }

    getPreviewURL(): string {
        return api.voirGrilleExpertise
            .replace('{langue}', this.data.language)
            .replace('{id}', '' + this.data.id);
    }

    getDownloadURL(): string {
        return this.getPreviewURL() + '/pdf';
    }


    download() {
        this.toolService.download(
            {
                url: this.getDownloadURL(),
                originalFilename: 'expertise-' + this.data.id + '-' + (new Date()).getTime() + '.pdf'
            }
        );
    }

    editHtml() {
        if (document.getElementById('iframeViwewer')) {
            document.getElementById('iframeViwewer').remove();
        }

        this.sommaire = [];
        const iframe = document.createElement('iframe');
        let html = this.texte;
        html = html.replace('class="container"', '');
        html = html.replace('<html>', '<html style="overflow: hidden">');
        document.getElementById('content').appendChild(iframe);
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(html);
        iframe.contentWindow.document.close();
        iframe.setAttribute('id', 'iframeViwewer');
        iframe.setAttribute('width', '100%');
        iframe.setAttribute('height', '100%');
        iframe.setAttribute('style', 'border:none; display:block;');


        window.setTimeout(() => {
            iframe.setAttribute(
                'min-height',
                iframe.contentWindow.document.body.scrollHeight + 'px'
            );
            iframe.setAttribute(
                'height',
                iframe.contentWindow.document.body.scrollHeight + 'px'
            );
            const titres = iframe.contentWindow.document.getElementsByTagName(
                'h3'
            ) as any;
            for (let i = 0; i < titres.length; i++) {
                const item = titres[i] as HTMLElement;
                const id = this.toolService.getGUID();
                item.setAttribute('id', id);
                this.sommaire.push({
                    scrollTo: item.offsetTop,
                    label: item.innerText,
                });
            }
        }, 500);
    }

    ngAfterViewInit(): void {
        this.loadHTML();
    }
}
